import { useEffect } from 'react';
import { useAuth } from './auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Spin, Typography, Flex } from 'antd';
import { AuthErrorView } from './RequireAuth';

const { Text } = Typography;

export default function Callback() {
  const { authenticated, authError, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // The AuthContext handles the OAuth callback automatically
    // Once authenticated, redirect to home page
    if (authenticated) {
      navigate('/', { replace: true });
    }
  }, [authenticated, navigate]);

  if (authError) {
    return <AuthErrorView message={authError} onRetry={login} />;
  }

  return (
    <Flex
      vertical
      justify="center"
      align="center"
      gap={16}
      style={{ minHeight: '100vh' }}
      role="status"
      aria-live="polite"
    >
      <Spin size="large" />
      <Text style={{ fontSize: 16 }}>Signing you in…</Text>
    </Flex>
  );
}
